import React, {Component} from 'react';
import PropTypes from "prop-types";

import FilterRadioButton from '../filterRadioButton';
import FilterCheckButton from '../filterCheckButton';

import FilterContainerStyle from '../../modules/FilterContainer.module.scss';
import styles from "../../modules/Filters.module.scss";

export class Index extends Component {
    checkSelected;
    filterContainerRef = React.createRef();

    document = document;

    componentDidMount() {
        this.document.addEventListener('mousedown', this.handleClickOutside, false);
        this.checkSelected = this.selectedTagFlag(this.props.filterOptions);
    }

    componentWillUnmount() {
        this.document.removeEventListener('mousedown', this.handleClickOutside, false);
    }

    handleClickOutside = event => {
        if (this.filterContainerRef.current && !this.filterContainerRef.current.contains(event.target)) {
            this.props.closeFilterContainer(this.props.filterName);
        }
    };

    selectedTagFlag = filterOptions => {
        let count = 0;
        filterOptions.forEach(element => {
            if (element.value !== '' && element.checked) {
                count++;
            }
        })

        return count;
    }

    containerStyle = () => {
        const selectedStyle = (this.checkSelected > 0 ? FilterContainerStyle.ContainSelectedFilters : '');
        return `${FilterContainerStyle.dropdown} ${selectedStyle}`;
    }

    dropdownMenuStyle = () => {
        const activeStyle = this.props.open ? FilterContainerStyle.active : '';
        const showStyle = this.props.open ? FilterContainerStyle.show : '';
        return `${FilterContainerStyle.dropdownMenu} ${showStyle} ${activeStyle} ${styles.subMenuItem}`;
    }

    getSelectedFilterOption(filterOptions) {
        if (!this.props.filtersVisible) {
            return [];
        }

        return filterOptions
            .filter(option => {
                return option.checked === true && parseInt(option.value) > 0
            })
            .map(option => option.label);
    }

    renderFilterOptions(options) {
        if (options.length > 0) {
            return `(${options.join(", ")})`
        } else {
            return '';
        }
    }

    render() {
        const {filterName, filterOptions, onChange, open, loadingFilters, onclickGAEvent} = this.props;

        const selectedFilterLabels = this.getSelectedFilterOption(filterOptions);

        return (<React.Fragment>
            <div
                className={this.containerStyle()}
                attr-selected={this.checkSelected}
                ref={this.filterContainerRef}>
                <button
                    type="button"
                    className={`${FilterContainerStyle.btn} ${FilterContainerStyle.filterToggler}`}
                    disabled={filterOptions.length === 0}
                    data-name={filterName}>
                    {filterName}
                    <div
                        className={FilterContainerStyle.selectedFilters}>{this.renderFilterOptions(selectedFilterLabels)}</div>
                </button>
                <div className={this.dropdownMenuStyle()}>
                    <div className={styles.filterOptionsHeader} style={{textAlign: 'center'}}
                         data-back={true}>{filterName}</div>
                    {open && (<>
                        {filterOptions.map(value => {

                            if (value.type === 'checkbox') {
                                return <FilterCheckButton
                                    key={value.id}
                                    element={value}
                                    onChange={onChange}
                                    loadingFilters={loadingFilters}
                                    onclickGAEvent={onclickGAEvent}
                                    gaActionName={filterName}
                                />;
                            }
                            return <FilterRadioButton
                                key={value.id}
                                element={value}
                                onChange={onChange}
                                loadingFilters={loadingFilters}
                                onclickGAEvent={onclickGAEvent}
                                gaActionName={filterName}
                            />;
                        })}
                    </>)}
                </div>
            </div>
        </React.Fragment>)
    }
}

Index.propTypes = {
    closeFilterContainer: PropTypes.func,
    filterOptions: PropTypes.array,
    filterName: PropTypes.string,
    open: PropTypes.bool,
}

export default Index;